import styled from "styled-components/macro";

import { QuestionButton } from "../../components/FAQSection/styles";
import {
  Button,
  Card,
  CardHeader,
  Category,
  CategoryContainer,
  Description,
  Divider,
  Meeting,
  Price,
  PriceContainer,
  Tag,
  Title,
} from "../../components/TariffSection/styles";
import {
  Section as BaseSection,
  SmallTitle,
  TitleH2
} from "../../styles/sharedStyles";

export const CLevelThemeScope = styled.div`
  ${Card} {
    background-color: #07060A;
    border-color: rgba(180, 180, 180, 0.3);
  }

  ${CardHeader} {
    display: none;
  }

  ${CategoryContainer} {
    margin-top: 32px;
  }

  ${Category} {
    color: rgba(255, 255, 255, 1);
  }

  ${Divider} {
    border-top-color: rgba(180, 180, 180, 0.3);
  }

  ${Description} {
    color: #B4B4B4;
  }

  ${Meeting} {
    color: #B4B4B4;
  }

  ${Price} {
    color: rgba(255, 255, 255, 1);
  }
  
  ${PriceContainer} {
    height: 111px;
  }

  ${TitleH2} {
    color: #FFFFFF;

    span {
      color: inherit;
    }
  }

  ${SmallTitle} {
    color: #FFFFFF;
  }
  
  ${Tag} {
    display: none;
  }

  ${Button} {
    color: #141414;
  }

  ${Button} span {
    color: inherit;
  }

  ${Button}:hover {
    color: #141414;
    border-color: #fff;
  }

  ${Button}:hover span {
    color: #141414;
  }

  @media (min-width: 980px) and (max-width: 1439px) {
    ${Title} {
      font-size: 30px;
    }
  }
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const WorkflowSection = styled(BaseSection)`
  margin-bottom: 0;

  @media (max-width: 1439px) {
    margin-bottom: 0;
  }

  @media (max-width: 979px) {
    margin-bottom: 0;
  }
`

export const CustomTitleH2 = styled(TitleH2)`
  max-width: 100%;
`

export const CareerAuditFAQScope = styled.div`
  width: 100%;

  ${QuestionButton} {
    border-color: #1983FF;
  }
`
